import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ModalController } from '@ionic/angular';
import { AuthenticationPageComponent } from 'src/app/auth/pages/authentication-page/authentication-page.component';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService,
              private router: Router,
              private settingService: SettingService,
              private modalCtrl: ModalController,) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
  //save url in cache and redirect there once logged in
    localStorage.setItem('Stateurl',state.url);
    if (state.url == "/account/offers" && this.settingService.configuration.hideMemberProgram) {
      //This page has 2 way to be consulted. Page supporting members will ask the login before getting in the page
      //or page not supporting members must go through without getting asked to register/login
      return true;
    }

    
    if (!this.authService.isAuthenticated) {
      /*
      if(this.settingService.configuration.uIoptions?.loginToPopup) {
          
        // prevents crash if the undocked navbar is inside a popup
        const modal = await this.modalCtrl.create({
          component: AuthenticationPageComponent,
          cssClass: 'auth-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      } else {
        return this.router.parseUrl('/auth');
      }
      */

      if(!state.url?.includes('/account/pay-rewards') && !state.url?.includes('/account/plus')) {
        return this.proceedToLogin()
      } else {
        if(!this.settingService.configuration?.uIoptions?.extendedRewards) {
          return this.proceedToLogin()
        }
      }
    }
    

    return true;
  }

  proceedToLogin() {
    if(this.settingService.configuration.uIoptions?.allinOneAuthPage) {
      return this.router.parseUrl('/auth/fullauth');
    } else {
      return this.router.parseUrl('/auth');
    }
  }
}
